"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.ModalOpen = void 0;
var react_1 = __importStar(require("react"));
var utils_1 = require("@lglp/utils");
var ramda_1 = require("ramda");
var Button_1 = require("../Button");
var ModalContext_1 = require("./ModalContext");
exports.ModalOpen = react_1.memo(function (props) {
    var disabled = props.disabled, className = props.className, rest = __rest(props, ["disabled", "className"]);
    var buttonRef = react_1.useRef();
    var _a = ModalContext_1.useModalContext(), opened = _a.opened, toggleOpen = _a.toggleOpen;
    react_1.useEffect(function () {
        if (!opened && utils_1.canUseDOM()) {
            var currentScrollX = ramda_1.propOr(window.pageXOffset, 'scrollX', window);
            var currentScrollY = ramda_1.propOr(window.pageYOffset, 'scrollY', window);
            buttonRef.current && buttonRef.current.focus({ preventScroll: true });
            window.scrollTo &&
                window.scrollTo(currentScrollX, currentScrollY);
        }
    }, [opened]);
    var onClick = function () {
        toggleOpen(!opened);
    };
    return (react_1["default"].createElement(Button_1.Button, __assign({ innerRef: buttonRef, onClick: onClick, disabled: disabled, className: ['modal_open', className] }, rest)));
});
//# sourceMappingURL=ModalOpen.js.map